export function newUiEnabled(): boolean {
  // Vite exposes env vars via import.meta.env.* at build/dev time.
  // This keeps the rollout behind an explicit local flag.
  return Boolean(import.meta.env.VITE_NEW_UI)
}

